/**
 * Enrichment for Scale Drop Modal – leads + tag filter options
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMemo } from 'react';
import type { UseQueryResult } from '@tanstack/react-query';
import type { ListPerformanceTagsResponse } from '@/hooks';
import type { LeadsList } from '@/hooks';

export function useScaleDropEnrichment(
  perfTagsQuery: UseQueryResult<ListPerformanceTagsResponse>,
  leadsLists: LeadsList[],
) {
  const enrichedLeads = useMemo(() => {
    const byId = perfTagsQuery.data?.tagsByWiserId ?? {};
    return leadsLists.map((l) => ({ ...l, performanceTags: byId[l.id] ?? [] }));
  }, [leadsLists, perfTagsQuery.data?.tagsByWiserId]);

  const tagFilterOptions = useMemo(() => {
    const byListId = perfTagsQuery.data?.tagsByListId ?? {};
    const byWiserId = perfTagsQuery.data?.tagsByWiserId ?? {};
    const set = new Set<string>(['New', 'Unused']);
    for (const tags of Object.values(byListId)) {
      for (const t of tags) if (t && String(t).trim()) set.add(String(t).trim());
    }
    for (const tags of Object.values(byWiserId)) {
      for (const t of tags) if (t && String(t).trim()) set.add(String(t).trim());
    }
    return [...set].sort();
  }, [perfTagsQuery.data?.tagsByListId, perfTagsQuery.data?.tagsByWiserId]);

  return { enrichedLeads, tagFilterOptions };
}
